import React, { Component } from 'react';


export default class extends Component {
	render() { 
		const { alert } = this.props;     
		let style = 'alert-success';
		if (alert.type === 'error') {
			style = 'alert-danger';
		}		  
		return (			
			<div className={'text-center alert ' + style} role="alert" key={alert.message}>
				{alert.message}
			</div>
		);		
	}
}




// WEBPACK FOOTER //
// ./src/views/membership/components/Alert.js